<template>
  <div>
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
    <material-snackbar
      v-model="snackbar.show"
      :type="snackbar.type"
      timeout="5000"
      v-bind="{
        bottom: true,
        right: true,
        color: snackbar.color,
      }"
    >
      {{ snackbar.text }}
    </material-snackbar>
  </div>
</template>

<script>
  // Styles
  import '@/styles/overrides.sass'
  import AppEvents from './events'
  import { snackbarOpen } from '@/util/helpers'

  export default {
    name: 'App',
    metaInfo: {
      // title: '제넥신',
      // title: '한독',
      title: '네오비젼',
      // title: '한국투자리얼에셋운용',
      titleTemplate: '%s | 회의실 예약 시스템',
      htmlAttrs: { lang: 'en' },
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      ],
    },

    data: () => ({
      snackbar: {
        show: false,
        color: 'pink',
        text: '',
        type: 'error',
      },
    }),

    created () {
      AppEvents.forEach(item => {
        this.$on(item.name, item.callback)
      })

      window.getApp = this

      this.$http.interceptors.response.use(
        function (response) {
          return response
        },

        function (error) {
          try {
            if (error.response.data.error === 'access denied.') {
              window.getApp.$emit('APP_LOGOUT')
              return snackbarOpen('success', '세션이 만료되어 로그아웃 되었습니다.', 'success')
            } else {
              return Promise.reject(error)
            }
          } catch (err) {
            return Promise.reject(err)
          }
        },
      )
    },

    mounted () {
      const user = this.$cookies.get('user')
      if (user) {
        this.$store.set('user/info', user)
        this.$store.set('user/token', user.token)
        this.$http.defaults.headers.common.Authorization = 'Bearer ' + user.token
      } else {
        // console.log('window.location.pathname.indexOf(\'comeIn\') :: ' + window.location.pathname)
        // console.log('window.location.pathname.indexOf(\'comeIn\') :: ' + window.location.pathname.indexOf('comeIn'))
        if (window.location.pathname.indexOf('sso') === -1) {
          this.$router.replace('/')
        }

        if (window.location.pathname.indexOf('comeIn') === 1) {
          this.$router.replace('/comeIn')
        }
      }
    },
  }
</script>
